import type { CustomCellEditorProps } from "ag-grid-react";
import { type FC, useEffect, useState } from "react";
import { ColorButton } from "widgets";

import { getCssColor } from "../../../../../app-utils/color.js";
import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import { TableCell } from "../core/TableCell.js";

const ColorCell: FC<IAgGridCellProps> = (props) => {
  const color = props.value;

  return (
    <TableCell>
      <ColorButton
        defaultColor={color}
        onClick={() => props.api.startEditingCell({ rowIndex: props.node.rowIndex, colKey: props.column })}
        size="tiny"
      />
    </TableCell>
  );
};

const ColorCellEditor = (props: CustomCellEditorProps) => {
  const { value } = props;
  const [color, setColor] = useState<string>(getCssColor(value));

  const onChangeListener = (newColor: string) => {
    setColor(newColor);
    props.onValueChange(newColor);
  };

  // this is a workaround to open the color picker immediately, because the isOpen of Dialog to true does misplace the dialog
  const [isColorPickerOpen, setColorPickerOpen] = useState<boolean>(false);
  useEffect(() => {
    setTimeout(() => {
      setColorPickerOpen(true);
    });
  }, []);

  return (
    <TableCell>
      <ColorButton
        defaultColor={color || "#ffffff"}
        isOpen={isColorPickerOpen}
        onApply={onChangeListener}
        onClose={() => {
          setColorPickerOpen(false);
          setTimeout(() => {
            props.api.stopEditing();
          });
        }}
        size="tiny"
      />
    </TableCell>
  );
};

export { ColorCell, ColorCellEditor };
